export default __webpack_public_path__ + "6934558a2095332b9a5bb31feaa41f2f.webp";